/**
 * @generated SignedSource<<d370a1b684bd937c99d71113f8af3478>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SetTxnsNeedsReviewInputObject = {
  needsReview: boolean;
  txnIds: ReadonlyArray<string>;
};
export type stakeholderTxnsDialog_SetTxnsNeedsReviewMutation$variables = {
  input: SetTxnsNeedsReviewInputObject;
};
export type stakeholderTxnsDialog_SetTxnsNeedsReviewMutation$data = {
  readonly setTxnsNeedsReview: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly updatedCount: number;
  } | null | undefined;
};
export type stakeholderTxnsDialog_SetTxnsNeedsReviewMutation = {
  response: stakeholderTxnsDialog_SetTxnsNeedsReviewMutation$data;
  variables: stakeholderTxnsDialog_SetTxnsNeedsReviewMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "stakeholderTxnsDialog_SetTxnsNeedsReviewMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetTxnsNeedsReviewMutationPayload",
        "kind": "LinkedField",
        "name": "setTxnsNeedsReview",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "stakeholderTxnsDialog_SetTxnsNeedsReviewMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetTxnsNeedsReviewMutationPayload",
        "kind": "LinkedField",
        "name": "setTxnsNeedsReview",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "75d997492cfe52d074cc1f139f78bfd0",
    "id": null,
    "metadata": {},
    "name": "stakeholderTxnsDialog_SetTxnsNeedsReviewMutation",
    "operationKind": "mutation",
    "text": "mutation stakeholderTxnsDialog_SetTxnsNeedsReviewMutation(\n  $input: SetTxnsNeedsReviewInputObject!\n) {\n  setTxnsNeedsReview(input: $input) {\n    updatedCount\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "501ce20506cb5dc5216176260e5fd967";

export default node;
